import enrolmentStatus from '../response/accounts/accounting-enrolment-status.json';
import myobLoginUri from '../response/accounts/accounting-myob-login-uri.json';
import xeroLoginUri from '../response/accounts/accounting-xero-login-uri.json';

export default function AccountingIntegrationRoutes() {
  // Get Enrolment Status
  this.get('accounts-api/v1/accounting/:contractIdentifier/enrolment', () => enrolmentStatus);

  // Get MYOB login URI
  this.get('accounts-api/v1/accounting/myob/loginUri', () => myobLoginUri);

  // Disconnect from MYOB
  this.post('accounts-api/v1/accounting/myob/:contractIdentifier/disconnect', () => {});

  // Get Xero login URI
  this.get('accounts-api/v1/accounting/xero/loginUri', () => xeroLoginUri);

  // Connect to Xero
  this.post('accounts-api/v1/accounting/xero/:contractIdentifier/connect', () => {});

  // Disconnect from Xero
  this.post('accounts-api/v1/accounting/xero/:contractIdentifier/disconnect', () => {});
}
